import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import Avatar from "components/Illustrations/Avatar";

const OPEN = '#F08A6E';
const MEMBERS = [
  {x: 120, y: 36, color: '#F08A6E'},
  {x: 176, y: 90, color: '#5BA8DE'},
  {x: 64, y: 90, color: '#7FC79A'},
];
const DOTS = [112, 120, 128];

// Some members are in, one place is still open: the open seat pulses and its
// link keeps flowing while the centre waits.
const useStyles = makeStyles({
  ring: {
    transformOrigin: '120px 90px',
    animation: '$spin 30s linear infinite',
  },
  member: {
    animation: '$float 3s ease-in-out infinite',
  },
  link: {
    strokeDasharray: '3 5',
    animation: '$flow .8s linear infinite',
  },
  seat: {
    transformBox: 'fill-box',
    transformOrigin: '50% 50%',
    animation: '$breathe 2.4s ease-in-out infinite',
  },
  ripple: {
    transformBox: 'fill-box',
    transformOrigin: '50% 50%',
    animation: '$ripple 2.4s ease-out infinite',
  },
  dot: {
    animation: '$dot 1.4s ease-in-out infinite',
  },
  '@keyframes spin': {
    to: {transform: 'rotate(360deg)'},
  },
  '@keyframes float': {
    '0%, 100%': {transform: 'translateY(0)'},
    '50%': {transform: 'translateY(-4px)'},
  },
  '@keyframes flow': {
    to: {strokeDashoffset: -8},
  },
  '@keyframes breathe': {
    '0%, 100%': {transform: 'scale(1)'},
    '50%': {transform: 'scale(1.06)'},
  },
  '@keyframes ripple': {
    '0%': {transform: 'scale(.9)', opacity: .7},
    '100%': {transform: 'scale(1.5)', opacity: 0},
  },
  '@keyframes dot': {
    '0%, 60%, 100%': {transform: 'translateY(0)', opacity: .35},
    '30%': {transform: 'translateY(-5px)', opacity: 1},
  },
  '@media (prefers-reduced-motion: reduce)': {
    ring: {animation: 'none'},
    member: {animation: 'none'},
    link: {animation: 'none'},
    seat: {animation: 'none'},
    ripple: {animation: 'none', opacity: 0},
    dot: {animation: 'none', opacity: 1},
  },
});

const GroupHoldArt = ({className}) => {
  const classes = useStyles();

  return (
    <svg className={className} viewBox="30 6 180 168" fill="none" stroke="#2B3A55" strokeWidth={3}
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx={120} cy={90} r={80} fill="#FFF6E5" stroke="none"/>
      <circle cx={120} cy={90} r={56} fill="#FDEBC4" stroke="none"/>
      <circle className={classes.ring} cx={120} cy={90} r={46} stroke="#F6C343" strokeWidth={2.5}
              strokeDasharray="2 9"/>
      <path d="M120 72V56M138 90h18M102 90H84" stroke="#5BA8DE"/>
      <path className={classes.link} d="M120 108v18" stroke={OPEN}/>
      <circle className={classes.ripple} cx={120} cy={144} r={18} stroke={OPEN} strokeWidth={2.5}/>
      <g className={classes.seat}>
        <circle cx={120} cy={144} r={18} fill="#fff" stroke={OPEN} strokeWidth={2.5} strokeDasharray="4 4"/>
        <path d="M120 137v14M113 144h14" stroke={OPEN}/>
      </g>
      {MEMBERS.map(({x, y, color}, index) => (
        <g key={color} className={classes.member} style={{animationDelay: `${-index}s`}}>
          <Avatar x={x} y={y} size={0.9} color={color}/>
        </g>
      ))}
      <circle cx={120} cy={90} r={17} fill="#fff"/>
      {DOTS.map((x, index) => (
        <circle key={x} className={classes.dot} style={{animationDelay: `${index * 0.2}s`}} cx={x} cy={90}
                r={2.8} fill="#2B3A55" stroke="none"/>
      ))}
    </svg>
  );
};

export default GroupHoldArt;
